export enum BlockType {
    // Action step, will only execute when explicitly triggered, does not store or process (form)data.
    action = 'action',
    // Activity step, will only execute when explicitly triggered, creates one oe more activities.
    activity = 'activity',
    // Enables one or more succeeding activity- and action-steps. Only one of those can be executed.
    choice = 'choice',
    // Will be run immediately after the previous step is finished without further user interaction.
    general = 'general',
    // Schedules completion of the step at a specific time.
    scheduled = 'scheduled',
    // Starting point that can be used by a user or external system.
    start = 'start',
    // like an action step, but will be triggered from code, not by a user action
    systemAction = 'systemAction',
}
